import React from "react";
import { BadgeCheck } from "lucide-react";
import { cn } from "@/lib/utils";

/** True when org Circa Social profile was verified in Management Suite. */
export function isOrgVerified(org) {
  return Boolean(org?.is_verified || org?.isVerified);
}

/**
 * Compact verified checkmark next to an org display name.
 */
export default function VerifiedOrgMark({
  org,
  className,
  title = "Verified organization",
}) {
  if (!isOrgVerified(org)) return null;
  return (
    <BadgeCheck
      className={cn(
        "inline h-3.5 w-3.5 shrink-0 text-sky-600 dark:text-sky-400",
        className
      )}
      aria-label={title}
      title={title}
    />
  );
}
